const prefix = 'REACT_APP_'

declare global {
  interface Window {
    _env_: Record<string, string>
  }
}

function env(key: string, defaultValue?: string): string {
  const envVal =
    (process.env.NODE_ENV === 'development' ? process.env[`${prefix}${key}`] : window._env_[key]) || defaultValue
  if (!envVal) {
    throw new Error(`Environment variable ${key} missing with no default value`)
  }
  return envVal
}

export default {
  redirectBaseUrl: env('REDIRECT_BASE_URL', "https://cleansheet-install.mckinsey-solutions.com"),
  clientId: env('CLIENT_ID', "f6fcea03-c60e-4ee1-b978-f6e558b0961f"),
  oidcConfigUrl: env('OIDC_CONFIG_URL', "https://auth.mckinsey.id/auth/realms/r/.well-known/openid-configuration"),
}
